import { createAction } from '@reduxjs/toolkit';

import { JurisdictionFromApi } from '../../models';

export const onFetchingJurisdictions = createAction('jurisdictions/onFetching');
export const onJurisdictionsReceived = createAction<JurisdictionFromApi[]>('jurisdictions/onReceived');
export const onJurisdictionsFailed = createAction<unknown>('jurisdictions/onFailed');
